/**
 * Air Terminal Tool - Terminal Placement
 * 
 * Places air terminals (diffusers, grilles).
 */

import { v4 as uuidv4 } from 'uuid';
import { Element } from '../core/types';
import { BaseTool } from './BaseTool';
import { ThreeEvent } from '@react-three/fiber';
import * as THREE from 'three';

export interface TerminalGeometryData {
    position: [number, number, number];
    rotation: number;
}

export interface TerminalElement extends Element {
    category: 'Air Terminals';
    geometryData: TerminalGeometryData;
}

export class TerminalTool extends BaseTool {
    id = 'terminal';
    name = 'Air Terminal';
    cursor = 'crosshair';

    onPointerDown(event: ThreeEvent<PointerEvent>): void {
        if (!this.context) return;
        if (event.button !== 0) return;

        const point = this.getIntersection(event);
        if (!point) return;

        const snapped = this.snapToGrid(point);
        this.createTerminal(snapped);
    }

    onPointerMove(event: ThreeEvent<PointerEvent>): void {
        if (!this.context) return;
        const point = this.getIntersection(event);
        if (point) {
            const snapped = this.snapToGrid(point);
            this.context.appStore.setToolPreview({
                type: 'terminal',
                position: snapped
            });
        }
    }

    onPointerUp(_event: ThreeEvent<PointerEvent>): void { }

    private createTerminal(point: THREE.Vector3) {
        if (!this.context) return;

        const geometryData: TerminalGeometryData = {
            position: [point.x, point.y, point.z],
            rotation: 0
        };

        const terminal: TerminalElement = {
            id: uuidv4(),
            category: 'Air Terminals',
            type: 'Supply Diffuser: 600x600 Face',
            parameters: {
                'Flow': '235 L/s',
                'Size': '600x600 mm'
            },
            constraints: [],
            geometryData
        };

        this.context.bimStore.addElement(terminal);
    }
}
